import { certifications } from "api/certified-api";

/**
 * Genera los encabezados comunes para las peticiones.
 * @param {string} token - Token JWT.
 * @returns {Object} Headers estándar.
 */
const getHeaders = (token) => ({
	'Content-Type': 'application/json',
	'Accept': 'application/json',
	'x-access-token': token
});

/**
 * Obtiene todas las preguntas y respuestas de EPSt.
 */
export const fetchEpstQuestionsAnswers = async (token) => {
	const response = await certifications.get(`/epst/questions/answers`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene una pregunta con sus respuestas por ID.
 */
export const fetchEpstQuestionAnswersById = async (id, token) => {
	const response = await certifications.get(`/epst/questions/answers/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene preguntas por sección y tipo de candidato (1=Kids, 2=Adults).
 */
export const fetchEpstQuestionsSectionType = async (id, type, token) => {
	const response = await certifications.get(`/epst/questions/section/type/${id}/${type}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Obtiene la última pregunta creada de EPSt.
 */
export const fetchEpstLastQuestion = async (token) => {
	const response = await certifications.get(`/epst/last/question`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Elimina una pregunta de EPSt por ID.
 */
export const deleteEpstQuestionById = async (id, token) => {
	const response = await certifications.delete(`/epst/questions/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Elimina todas las respuestas de una pregunta de EPSt por ID.
 */
export const deleteEpstQuestionAnswersById = async (id, token) => {
	const response = await certifications.delete(`/epst/questions/answers/${id}`, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Crea una nueva pregunta EPSt.
 */
export const createQuestionEpst = async (data, token) => {
	const response = await certifications.post(`/epst/question`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


/**
 * Crea varias preguntas EPSt.
 */
export const createQuestionsEpst = async (data, token) => {
	const response = await certifications.post(`/epst/questions`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


/**
 * Crea una nueva respuesta EPSt.
 */
export const createAnswerEpst = async (data, token) => {
	const response = await certifications.post(`/epst/answers`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


/**
 * Crea una hoja de resultados (score sheet) para EPSt.
 */
export const createEpstScoreSheet = async (data, token) => {
	const response = await certifications.post(`/epst/score/sheet`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


/**
 * Actualiza una pregunta EPSt por su ID.
 */
export const updateEpstQuestionById = async (id, data, token) => {
	const response = await certifications.put(`/epst/questions/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};


/**
 * Actualiza una respuesta EPSt por su ID.
 */
export const updateEpstAnswerById = async (id, data, token) => {
	const response = await certifications.put(`/epst/answers/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

/**
 * Actualiza una respuesta EPSt por su ID.
 */
export const updateEpstQuestionMediaById = async (id, data, token) => {
	const response = await certifications.put(`/epst/questions/media/${id}`, data, {
		headers: getHeaders(token)
	});
	return response.data;
};

export const fetchEpstQuestionsReportHeaders = async (candidate_type, token) => {
	const response = await certifications.get(`/epst/questions/report/headers`, {
		headers: getHeaders(token),
		params: {
			candidate_type // por ejemplo: 1 o 2
		}
	});
	return response.data;
};